import React, { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import _size from 'lodash/size';
import {
  IFriendDating,
  useDating,
} from '../../../../../hooks/use-dating/useDating';
import {
  IChatDating,
  IGetChatDatingByIdPayload,
} from '../../../../../types/chat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../configuration';
import classNames from 'classnames';
import Loading from '../../../../../components/loading/loading.component';
import { useChatDatingDetail } from './useChatDetailDating';
// import dayjs from 'dayjs';

interface ChatContentProps {
  user: IFriendDating;
  newMessage: IChatDating | null;
}

const selfId = 'wrapper-chat-content';

const ChatContentDating = ({ user, newMessage }: ChatContentProps) => {

  const { datingProfile } = useDating({});

  const selfRef = useRef<HTMLDivElement>(null);

  const [pageNumber, setPageNumber] = useState(1);
  const {
    listChat,
    appendMessage,
    loading,
    hasMore,
    loadMoreChat,
    pagingStateFirst,
    pagingStateLast,
  } = useChatDatingDetail({
    pageNumber,
    friendId: user.profileId,
  });

  const handleLoadMoreChat = async () => {
    setPageNumber((prev) => prev + 1);

    const payload: IGetChatDatingByIdPayload = {
      pagingStateFirst,
      pagingStateLast,
      receiverProfileId: user.profileId,
      pageNumber: pageNumber + 1,
      pageSize: 20,
    };
    await loadMoreChat(payload);
  };

  useEffect(() => {
    if (!newMessage) {
      return;
    }

    const isMyMessage =
      newMessage.senderUserId === user.profileId ||
      newMessage.senderUserId === datingProfile?.profileId;
    if (isMyMessage) {
      appendMessage(newMessage);
    }
  }, [newMessage, user]);

  return (
    <div
      className={classNames(
        `overflow-auto h-[calc(100vh-279px)] p-3 flex flex-col-reverse w-full`,
        {
          'justify-center': !_size(listChat),
        }
      )}
      ref={selfRef}
      id={selfId}
    >
      <InfiniteScroll
        dataLength={_size(listChat)}
        next={async () => {
          await handleLoadMoreChat();
        }}
        hasMore={hasMore}
        loader={<Loading classname="mx-auto" />}
        endMessage={null}
        scrollableTarget={selfId}
        inverse
        style={{
          display: 'flex',
          flexDirection: 'column-reverse',
          overflow: 'visible',
        }}
      >
        <ul className="space-y-1.5">
          {listChat &&
            listChat.map((chat) =>
              chat.content ? (
                <li
                  key={chat.createdAt}
                  className={classNames(`flex gap-2  `, {
                    'items-end flex-row-reverse':
                      chat.senderUserId === datingProfile?.profileId,
                  })}
                >
                  <div
                    className={classNames(
                      `px-3 text-base leading-7 max-w-sm  rounded-2xl text-[#18191E] border p-5`,
                      {
                        ' rounded-br-md  ':
                          chat.senderUserId === datingProfile?.profileId,
                        ' rounded-tl-md bg-[#F8F9FB] max-w-sm':
                          chat.senderUserId !== datingProfile?.profileId,
                      }
                    )}
                  >
                    {chat.content}
                  </div>

                  {/* <div className="mt-1">
                    <p className="text-xs text-slate-600 dark:text-slate-100 text-right">
                      {dayjs(chat.createdAt).fromNow()}
                    </p>
                  </div> */}
                </li>
              ) : null
            )}
        </ul>

        {!_size(listChat) && !loading ? (
          <p className="text-sm text-slate-800 dark:text-slate-50 text-center">
            Bạn và {user.nickname} chưa có cuộc trò chuyện nào
          </p>
        ) : null}
      </InfiniteScroll>
    </div>
  );
};

export default ChatContentDating;
